import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DetailCard from '../components/DetailCard';
import DetailHeader from '../components/DetailHeader';
import InfoList from '../components/InfoList';
import LoadStatus from '../components/LoadStatus';
import StatusBadge from '../components/StatusBadge';
import InquiryAnswerForm from './InquiryAnswerForm';
import { getInquiry } from './inquiryApi';
import { INQUIRY_STATUS_LABELS } from './inquiryStatus';

const BACK = { backTo: '/admin/inquiries', backLabel: '문의사항 목록' };

// 문의사항 상세 화면. 작성자 정보, 문의 내용, 답변을 보여주고 답변 대기면 답변 폼을 띄운다.
export default function InquiryDetailPage() {
    const { inquiryId } = useParams();
    const [item, setItem] = useState(null);
    const [error, setError] = useState('');

    // 문의 상세를 불러온다.
    const load = useCallback(async () => {
        setError('');
        setItem(null);
        try {
            setItem(await getInquiry(inquiryId));
        } catch (loadError) {
            setError(loadError.message);
        }
    }, [inquiryId]);

    useEffect(() => { load(); }, [load]);

    if (!item) return <><DetailHeader {...BACK} title="문의사항" /><LoadStatus error={error} onRetry={load} /></>;
    const answered = item.status === 'answered';

    return (
        <>
            <DetailHeader {...BACK} title={item.title} aside={<StatusBadge label={INQUIRY_STATUS_LABELS[item.status] || item.status} done={answered} />} />
            <DetailCard title="기본 정보">
                <InfoList items={[
                    { label: '작성자', value: item.user_name },
                    { label: '이메일', value: item.user_email },
                    { label: '사용자 ID', value: item.user_id },
                    { label: '작성일', value: item.created_at },
                    { label: '답변일', value: item.answered_at },
                ]} />
            </DetailCard>
            <DetailCard title="문의 내용"><p>{item.content}</p></DetailCard>
            <DetailCard title="답변">
                {answered ? <p>{item.answer}</p> : <InquiryAnswerForm inquiryId={String(item.id)} onAnswered={load} />}
            </DetailCard>
        </>
    );
}
